import { createStore } from "vuex";

import componentModule from "./modules/component";
import messageModule from "./modules/message";
import userModule from "./modules/user";
import themeModule from "./modules/theme";

const store = createStore({
  modules: {
    componentModule,
    messageModule,
    userModule,
    themeModule,
  },
});

export default store;

declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {
    $store: typeof store;
  }
}
